require('./mortgageRequestSimpleNoteRequestStep3.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @ utils
const { getEstatesToRequest } = require('utilities/mortgageHelper');

// @ components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const MortgageRequestSimpleNoteSuccessful = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteRequest/mortgageRequestSimpleNoteSuccessful/mortgageRequestSimpleNoteSuccessful');

// @ constants
const { MORTGAGE_REQUEST_SIMPLE_NOTE } = require('constants/operationTypes');
const { SECOND_STEP, EURO_TEXT, CHARGE_ACCOUNT_PREFIX } = require('constants/index');
const { DATOS_VIV } = require('constants/mortgageRequestStates');

const MortgageRequestSimpleNoteRequestStep3 = props => {
    const {
        immSimpleNoteRequest,
        immPayment,
        immAccounts,
        immEstates,
        summaryDocumentation,
        immState,
        history
    } = props;

    const currentState = immState.get('estado');
    const mortgageStateFlag = currentState !== DATOS_VIV;
    if(mortgageStateFlag){
        history.push('/myprofile/mortgage/simple-note');
    }

    const immStep = immSimpleNoteRequest.getIn(['steps', SECOND_STEP]);
    const paymentAccount = immPayment.get('paymentAccount').replace(/\s/g, '');
    const codbban = paymentAccount.substr(4);
    const controlDigits = paymentAccount.substr(2, 2);
    const countryCode = paymentAccount.substr(0, 2);

    const accountId = immStep.get('accountId');
    const immAccount = immAccounts.getIn(['byId', accountId]);
    const contractNumber = immAccount.get('newContractNumber');
    const product = immAccount.get('newProduct');

    const destinationAccount = `${countryCode}${controlDigits}${codbban}`;
    const originAccount = `${CHARGE_ACCOUNT_PREFIX}${product}${contractNumber}`;
    const estatesToRequest = getEstatesToRequest(immEstates, summaryDocumentation);
    const paymentImport = immPayment.get('simpleNoteCost') * estatesToRequest.length;

    const operationParams = {
        'ammount': paymentImport,
        'currency': EURO_TEXT,
        destinationAccount,
        originAccount
    };

    return (
        <div>
            <div className="row mortgage-request-simple-note-request__title">
                <div className="col-xs-12">
                    <span>{formatText('mortgageRequestSimpleNoteRequest-confirmTitle')}</span>
                </div>
            </div>
            <div className="row mortgage-request-simple-note-request__subtitle">
                <div className="col-xs-12">
                    <span>{formatText('mortgageRequestSimpleNoteRequest-confirmSubTitle')}</span>
                </div>
            </div>

            <div className="row mortgage-request-simple-note-request__properties">
                <div className="col-xs-12">
                    <MortgageRequestSimpleNoteSuccessful showMessages={false} />
                </div>
            </div>

            <div className="row mortgage-request-simple-note-request__otp">
                <div className="col-xs-12">
                    <SignaturePattern
                        operationType={MORTGAGE_REQUEST_SIMPLE_NOTE}
                        operationParams={operationParams}
                    />
                </div>
            </div>
        </div>
    );
}

MortgageRequestSimpleNoteRequestStep3.propTypes = {
    immSimpleNoteRequest: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immEstates: PropTypes.object.isRequired,
    summaryDocumentation: PropTypes.object,
    immState: PropTypes.object,
    history: PropTypes.object,
}

module.exports = withRouter(MortgageRequestSimpleNoteRequestStep3);
